import * as React from "react";
import { isValidNumber } from "../../../../utils/number";
import { CommentStarForWeb } from "../../../../components/CommentStar";
import { InfoBottomView } from "./styles";
export const BottomViews = (props) => {
    const { collect } = props;
    return (React.createElement(InfoBottomView, { key: "bottomViews" },
        isValidNumber(collect === null || collect === void 0 ? void 0 : collect.score) ? (React.createElement(CommentStarForWeb, { rateScore: +((collect === null || collect === void 0 ? void 0 : collect.score) || 0) })) : (React.createElement("span", null, collect === null || collect === void 0 ? void 0 : collect.score)),
        collect && React.createElement("span", null, collect === null || collect === void 0 ? void 0 : collect.text)));
};
